const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'
const TOKEN_KEY = 'evapro_token'
const TOKEN_EXP_KEY = 'evapro_token_expires_at'

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY)
}

export function setAuthToken(token, expiresAt) {
  sessionStorage.setItem(TOKEN_KEY, token)
  if (expiresAt) {
    sessionStorage.setItem(TOKEN_EXP_KEY, expiresAt)
  }
}

export function clearAuthToken() {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_EXP_KEY)
}

export function hasValidSession() {
  const token = getToken()
  const expiresAt = sessionStorage.getItem(TOKEN_EXP_KEY)
  if (!token || !expiresAt) return false
  return new Date(expiresAt).getTime() > Date.now()
}

async function request(method, path, body = null, extraOptions = {}) {
  const headers = { ...extraOptions.headers }
  const token = getToken()

  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const opts = {
    method,
    headers,
    ...extraOptions,
  }

  if (body) {
    opts.body = body instanceof FormData ? body : JSON.stringify(body)
  }

  let res
  try {
    res = await fetch(`${API_URL}${path}`, opts)
  } catch {
    throw new Error('Impossible de joindre le serveur API')
  }

  if (res.status === 401) {
    clearAuthToken()
    throw new Error('Session expirée ou non autorisée')
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }))
    throw new Error(err.detail || 'Erreur API')
  }

  return res
}

export const api = {
  login: async (password) => {
    const data = await request('POST', '/auth/login', { password }).then(r => r.json())
    setAuthToken(data.token, data.expires_at)
    return data
  },

  logout: () => clearAuthToken(),

  getDossiers: () => request('GET', '/dossiers').then(r => r.json()),
  getDossier: (id) => request('GET', `/dossiers/${id}`).then(r => r.json()),
  createDossier: (data) => request('POST', '/dossiers', data).then(r => r.json()),
  updateDossier: (id, data) => request('PUT', `/dossiers/${id}`, data).then(r => r.json()),
  deleteDossier: (id) => request('DELETE', `/dossiers/${id}`).then(r => r.json()),

  generateDuer: async (id) => {
    const res = await request('POST', `/dossiers/${id}/generate`)
    const blob = await res.blob()
    const disposition = res.headers.get('content-disposition') || ''
    const match = disposition.match(/filename="?([^\"]+)"?/) || disposition.match(/filename\*=UTF-8''([^;]+)/)
    const filename = match ? decodeURIComponent(match[1]) : 'DUER.docx'
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
  },
}
